import type { AxiosResponse } from 'axios'
import type { FirmsApiResponse } from '@/types/firms.types.ts'
import type { PaymentsFirm } from '@/types/payments.types.ts'
import axios from 'axios'
import { useCookies } from 'vue3-cookies'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}firms/`

export const addFirm = async (data: URLSearchParams): Promise<AxiosResponse<FirmsApiResponse<PaymentsFirm>>> => {
  const { cookies } = useCookies()

  return axios.post(`${urlPrefix}add/`, data, {
    headers: {
      'X-CSRFToken': cookies.get('csrftoken'),
    },
  })
}
